import { routerReducer, RouterReducerState } from "@ngrx/router-store";
import { ActionReducerMap } from "@ngrx/store";
import { agentReducer } from "../reducers/agent.reducer";
import { applicationDetailsReducer } from "../reducers/application-details.reducer";
import { automationReducer } from "../reducers/automation.reducer";
import { connectionsReducer } from "../reducers/connection.reducer";
import { organizationReducer } from "../reducers/organization.reducer";
import { projectReducer } from "../reducers/project.reducer";
import { releaseReducer } from "../reducers/release.reducer";
import { testReportSummarizationReducer } from "../reducers/report-summarization.reducer";
import { testPrioritizationReducer } from "../reducers/test-prioritization.reducer";
import { testcaseGeneratorReducer } from "../reducers/testcase-generator.reducer";
import { AgentState } from "./agent.state";
import { ApplicationDetailsState } from "./application-details.state";
import { AutomationState } from "./automation.state";
import { ConnectionState } from "./connection.state";
import { OrganizationState } from "./organization.state";
import { ProjectState } from "./project.state";
import { releaseState } from "./release.state";
import { TestPrioritizationState } from "./test-prioritization.state";
import { TestCaseGeneratorState } from "./testcase-generator.state";
import { TestReportSummarizationState } from "./testReport.state";

export interface AppState {
  router: RouterReducerState<any>;
  organization: OrganizationState;
  project: ProjectState;
  connection: ConnectionState;
  testReport: TestReportSummarizationState;
  applicationDetails: ApplicationDetailsState;
  testcaseGenerator: TestCaseGeneratorState,
  testPrioritization: TestPrioritizationState
  automation: AutomationState,
  agent: AgentState,
  release:releaseState
}

export const appReducer: ActionReducerMap<AppState> = {
  router: routerReducer,
  organization: organizationReducer,
  project: projectReducer,
  connection: connectionsReducer,
  testReport: testReportSummarizationReducer,
  applicationDetails: applicationDetailsReducer,
  testcaseGenerator: testcaseGeneratorReducer,
  testPrioritization: testPrioritizationReducer,
  automation: automationReducer,
  agent: agentReducer,
  release: releaseReducer
};
